<style lang="scss">

</style>

<template>
  <section class="pt-0">
    <h3 class="font-weight-bolder mb-2">
      Change Password
    </h3>

    <validation-observer ref="observer" v-slot="{ handleSubmit }">
      <b-form @submit.stop.prevent="handleSubmit(updateProfilePassword)">
        <section class="mb-2">
          <label class="font-weight-bolder">Old Password</label>
          <validation-provider
            v-slot="validationContext"
            name="Old Password"
            :rules="{ required: true }"
          >
            <b-input-group class="mb-1">
              <b-form-input v-model="password.old_password" :state="getValidationState(validationContext)"
                            :type="showPassword ? 'text' : 'password'" placeholder="Enter old password*" />
              <b-input-group-append>
                <b-button @click="showPassword = !showPassword">
                  <i class="fas" :class="showPassword ? 'fa-eye' : 'fa-eye-slash'" />
                </b-button>
              </b-input-group-append>
            </b-input-group>

            <small class="text-danger">{{ validationContext.errors[0] }}</small>
          </validation-provider>
        </section>

        <section class="mb-2">
          <label class="font-weight-bolder">New Password</label>
          <validation-provider
            v-slot="validationContext"
            name="New Password"
            :rules="{ required: true, min: 8 }"
          >
            <b-input-group class="mb-1">
              <b-form-input v-model="password.new_password" :state="getValidationState(validationContext)"
                            :type="showPassword2 ? 'text' : 'password'" placeholder="Enter new password*" />
              <b-input-group-append>
                <b-button @click="showPassword2 = !showPassword2">
                  <i class="fas" :class="showPassword2 ? 'fa-eye' : 'fa-eye-slash'" />
                </b-button>
              </b-input-group-append>
            </b-input-group>

            <small class="text-danger">{{ validationContext.errors[0] }}</small>
          </validation-provider>
        </section>

        <section class="mb-2">
          <label class="font-weight-bolder">Confirm New Password</label>
          <validation-provider
            v-slot="validationContext"
            name="New Password Confirm"
            :rules="{ required: true, is: password.new_password, min: 8 }"
          >
            <b-input-group class="mb-1">
              <b-form-input v-model="password.new_password_confirm" :state="getValidationState(validationContext)"
                            :type="showPassword3 ? 'text' : 'password'" placeholder="Re-enter new password*" />
              <b-input-group-append>
                <b-button @click="showPassword3 = !showPassword3">
                  <i class="fas" :class="showPassword3 ? 'fa-eye' : 'fa-eye-slash'" />
                </b-button>
              </b-input-group-append>
            </b-input-group>

            <small class="text-danger">{{ validationContext.errors[0] }}</small>
          </validation-provider>
        </section>

        <section class="d-flex full-width justify-content-end">
          <b-button variant="primary" type="submit">Change Password</b-button>
        </section>
      </b-form>
    </validation-observer>
  </section>
</template>

<script>

import PrisonUsersService from '@/services/PrisonUsersService';
import { PASSWORD_ERROR_CODES } from '@/constants/errorCodes';

export default {
  name: 'ProfileSecurity',
  components: {},
  props: {},
  data() {
    return {
      loading: false,
      showPassword: false,
      showPassword2: false,
      showPassword3: false,
      password: {
        old_password: '',
        new_password: '',
        new_password_confirm: '',
      },
    };
  },
  mounted() {},
  methods: {
    updateProfilePassword() {
      this.loading = true;
      PrisonUsersService.changePassword(this.password.old_password, this.password.new_password).then(() => {
        this.$toast.success('Updated password successfully', {
          toastClassName: ['toast-std', 'success-toast'],
        });
        this.$emit('refresh');
      }).catch(err => {
        this.$toast.error(this.getErrorMessage(err), { toastClassName: ['toast-std', 'warning-toast'] });
      }).finally(() => {
        this.loading = false;
      })
    },
    getErrorMessage(err) {
      const error = err.response && err.response.data && err.response.data.error;
      if (error === PASSWORD_ERROR_CODES.OLD_NEW_PASSWORD_SAME) return 'Your new password cannot be the same as your current password';
      if (error === PASSWORD_ERROR_CODES.INVALID_PASSWORD) return 'Your old password is incorrect';
      if (error === PASSWORD_ERROR_CODES.PASSWORD_TOO_SHORT) return 'Please enter a password of at least 8 characters';
      if (error === PASSWORD_ERROR_CODES.PASSWORD_TOO_LONG) return 'Please enter a password shorter than 128 characters';
      if (error === PASSWORD_ERROR_CODES.PASSWORD_INSECURE) return 'Please enter a more complex and secure password';
      return 'Could not update profile, please refresh and try again';
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    resetPasswordFields() {
      this.password = {
        old_password: '',
        new_password: '',
        new_password_confirm: '',
      };
    },
  },
};
</script>
